module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Medium.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/Roboto-Medium.woff2
// module id = 688
// module chunks = 0